import React from "react";

import { Steward } from "components/Common/TableStyle";

export const REFERENCE_COLUMN_DATA = [
  {
    dataIndex: "name",
    key: "name",
    title: "Name",
    width: "25%",
  },
  {
    dataIndex: "description",
    key: "description",
    title: "Description",
    render: text => <div className="whitespace-pre-line">{text}</div>,
    width: "65%",
  },
  {
    title: "Type",
    key: "reference_source_type",
    dataIndex: "reference_source_type",
    width: "20%",
    render: text => <div className="whitespace-pre-line">{text}</div>,
  },
  {
    title: "Drafter",
    width: "30%",
    key: "drafter",
    dataIndex: "drafter",
    render: text => <Steward name={text?.name} title={text?.role} />,
  },
  {
    title: "Approver",
    width: "30%",
    key: "approver",
    dataIndex: "approver",
    render: text => <Steward name={text?.name} title={text?.role} />,
  },
];
